<script>
  import {notificationUtils, $state as stateProvider} from 'root/angular-injector-provider';
  import SpinnerWithText from 'root/components/molecules/SpinnerWithText.svelte';
  import {default as store, service } from './bid-messaging.store'
  import TextArea from './ViewBidMessagesDialogTextArea.svelte'
  import {default as readMessagesStore, isUnread, updateSettings} from 'root/messaging/user-messaging.store';
  import createBidMessagingSubject from 'root/messaging/bid-messaging-subject';

  import * as TYPES from 'root/messaging/messaging-const';
  import Tab from 'rfp/bid-manager/main/core/actions/action/messaging/tabs/ViewBidMessagesDialogTab.svelte';
  import {BID_MANAGER} from 'root/states';

  export let hide, cancel, bidId, subjectType = TYPES.PUBLIC, showBidManagerLink = false;

  let newMessage = '', MessagesElement, loadingMessages = false, unreadMessages = {},
    modified = false, subjectTypeDetails = {},
    publicAvailabilityError = 'Loading';

  $: loadBidMessagingDetails(bidId, subjectType);
  $: unreadMessages = checkUnreadMessages($store.bidDetails, readMessagesStore);
  $: subjectTypeDetails = getSubjectTypeDetails($store.conversationType, $store.bidDetails);

  async function loadBidMessagingDetails(id, type) {
    loadingMessages = true;
    await notificationUtils().onLoad(() => service.initialize(id, type));
    publicAvailabilityError = checkAvailability($store.bidDetails);
    if(subjectType === TYPES.PUBLIC && publicAvailabilityError) await setConversationType(TYPES.PRIVATE);
    loadingMessages = false;
  }

  async function setConversationType(type){
    loadingMessages = true;
    await service.setConversationType(bidId, type);
    loadingMessages = false;
  }

  async function sendMessage(){
    if(newMessage && newMessage.trim()){
      await notificationUtils().onSave(() => service.sendMessage(bidId, $store.conversationType, newMessage))
      modified = true;
      newMessage = '';
      MessagesElement.firstElementChild.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }

  function checkUnreadMessages(bidDetails = {}, rmStore){
    if(!rmStore) return {};
    const lastMessages = bidDetails && bidDetails.messages || {};
    return Object.keys(lastMessages).reduce((acc, b) => {
      acc[b] = isUnread(createBidMessagingSubject(bidId, b), lastMessages[b]);
      return acc;
    }, {});
  }

  function close(){
    (modified? hide: cancel)();
  }

  function getSubjectTypeDetails(conversationType, bidDetails) {
    if(!bidDetails) return {};
    return TYPES.getTypeDetails(conversationType, bidDetails.userAccount.sideId === 'BUYER');
  }

  function openBidManager(){
    stateProvider().inNew(BID_MANAGER, {viewId: null, rfp: $store.bidDetails.rfpId});
  }

  function checkAvailability(bidDetails){
    if(!bidDetails) return 'loading';
    const stateStatus = bidDetails.states[bidDetails.states.length-1].status;
    switch (stateStatus){
      case 'CREATED':
        return 'You must send the bid before you can send messages to the hotel representative!';
      case 'BUYER_DRAFT':
        return 'You must send the bid before you can send messages to the hotel representative!';
      case 'COMPETITIVE_SENT':
      case 'COMPETITIVE_RECEIVED':
      case 'COMPETITIVE_DECLINED':
      case 'COMPETITIVE_RECEIVED_ACCEPTED':
      case 'COMPETITIVE_RESPONDED':
      case 'COMPETITIVE_REFUSED':
        return 'Messages cannot be send until the competitive bid response is sent and the buyer accepts offer into his program!';
      default:
        return '';
    }
  }

</script>

{#if $store.bidDetails}
  <div class="ModalContainer" close="{close}">
    <div class="ModalHeader">
      <div class="ModalTitleBox">
        <div class="MessageT1"
             data-icon-before="folder">
          {$store.bidDetails.rfpName}
        </div>

        <button class="aBtn asLarge asIcon CloseButton"
                on:click={close}
                data-icon="clear"
        />
      </div>

      <div class="MessageT2">
        <strong> {$store.bidDetails.hotelName}</strong> - {$store.bidDetails.hotelAddress}
      </div>
    </div>


    <div class="TabsContainer">
      <Tab selected="{$store.conversationType === TYPES.PUBLIC}"
           onClick="{() => setConversationType(TYPES.PUBLIC)}"
      >
        <div class="TabTitle"
             class:Unread={unreadMessages[TYPES.PUBLIC]}
             data-icon-before="forum">
          {TYPES.PUBLIC_LABEL}
        </div>
      </Tab>

      <Tab selected="{$store.conversationType === TYPES.PRIVATE}"
           onClick="{() => setConversationType(TYPES.PRIVATE)}"
      >
        <div class="TabTitle"
             class:Unread={unreadMessages[TYPES.PRIVATE]}
             data-icon-before="library_books">
          {TYPES.PRIVATE_LABEL}
        </div>
      </Tab>
      <Tab selected="{$store.conversationType === TYPES.PERSONAL}"
           onClick="{() => setConversationType(TYPES.PERSONAL)}"
      >
        <div class="TabTitle"
             class:Unread={unreadMessages[TYPES.PERSONAL]}
             data-icon-before="article">
          {TYPES.PERSONAL_LABEL}
        </div>
      </Tab>
    </div>

    <div class="TabHeader">
      <div>
        <div class="TabHeaderTitle">{subjectTypeDetails.label}</div>
        <div class="TabHeaderSubtitle">{subjectTypeDetails.description}</div>
      </div>

      <div>
        <button class="aBtn asLarge atLight"
                class:On={$readMessagesStore.settings.showBidStates}
                class:Off={!$readMessagesStore.settings.showBidStates}
                data-icon="{$readMessagesStore.settings.showBidStates? 'toggle_on': 'toggle_off'}"
                on:click={() => updateSettings('showBidStates', !$readMessagesStore.settings.showBidStates)}
        >
          Status Logs
        </button>

        {#if showBidManagerLink}
          <button class="aBtn asLarge atLight"
                  data-icon-after="navigate_next"
                  on:click={openBidManager}
          >
            Bid Manager
          </button>
        {/if}
      </div>
    </div>

    <div class="MessagesDialogBody">
      {#if loadingMessages}
        <SpinnerWithText />
      {:else if $store.conversationType === TYPES.PUBLIC && publicAvailabilityError}
        <div class="AvailabilityError">{publicAvailabilityError}</div>
      {:else}
        <div class="Messages" bind:this={MessagesElement}>
          {#each ($store.view || []) as item}
            {#if item.type === 'MESSAGE'}
              <div class="MessageContainer {item.side}">
                <div class="Message {item.side}">
                  <div class="MessageBody">
                    {#if item.picture}
                      <div class="MessageImage">
                        <img src="{`/images/users/${item.picture}`}"
                             loading="lazy"
                             on:error={() => item.picture = null}
                             alt="" />
                      </div>
                    {:else}
                      <div class="MessageImage" data-icon-before="person"></div>
                    {/if}
                    <div>
                      <div class="MessageFrom">{item.author} &bullet; {item.accountName}</div>
                      <div class="MessageText">{item.text || ''}</div>
                    </div>
                  </div>

                  <div class="MessageTime" data-icon-before="info">
                    Sent on {item.datetime}
                  </div>
                </div>
              </div>
            {:else if item.type === 'BID_STATUS' && $readMessagesStore.settings.showBidStates}
              <div class="BidStatus" data-icon-before="info">
                {item.label} &bullet; {item.datetime}
              </div>
              <!--{:else if item.type === 'DATE'}-->
              <!--  <div class="DateSeparator">{item.date}</div>-->
            {/if}
          {/each}

        </div>

        <div class="NewMessageForm">
          <div class="NewMessageTextArea">
        <TextArea bind:value="{newMessage}"
                  placeholder="Type Your Message..."
                  maxLength="1000"
                  maxHeight="65px"
        >
        </TextArea>
          </div>
          <button class="aBtn asLarge atLight asMain SendMessage"
                  on:click={sendMessage}
                  disabled="{!newMessage}"
          >
            {$store.conversationType === TYPES.PUBLIC? 'Send': 'Save'}
          </button>
        </div>
      {/if}
    </div>
  </div>
{:else}
  <SpinnerWithText />
{/if}

<style lang="stylus">

  .ModalContainer {
    border-radius: 3px;
    overflow: auto;
    background-color: white;
    box-shadow: 0 5px 24px 0 rgba(0,0,0,.5);
    display: flex;
    flex-direction: column;
    width: 640px;
    min-width: 640px;
    max-height: 95vh;
    max-width: 95vh;
  }

  .ModalHeader {
    border: 1px solid white;
    border-bottom: 0;
    background: #ECEFF1;
    border-radius: 3px 3px 0 0;
    padding: 16px;
    position: relative;
  }

  .MessageT1 {
    height: 18px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    background: #546E7A;
    color: white;
    border-radius: 4px;
    padding: 3px 8px;
    margin-right: 50px;
    align-items: center;
    font-size: 13px;

    &:before {
      font-size: 16px;
      height: 16px;
      padding-right: 4px;
    }
  }

  .CloseButton {
    position:absolute;
    top: 0;
    right: 0;
    z-index: 1;
    border-color: transparent !important;
    background: transparent !important;
  }

  .MessageT2 {
    font-size: 14px;
    color: rgba(38, 50, 56, 0.5);
    line-height: 18px;
    margin-top: 8px;
    font-weight: normal;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    strong {
      color: rgb(38, 50, 56);
      font-weight: bold;
    }
  }

  .TabsContainer {
    display: flex;
    height: 40px;
    padding-left: 25px;
    background: #ECEFF1;
    border: 1px solid white;
    border-top: 0;
    border-bottom: 0;
  }

  .TabTitle {
    position:relative;

    &:before {
      padding-right: 5px;
    }

    &.Unread:after {
      position: absolute;
      top: 5px;
      right: -10px;
      width: 8px;
      height: 8px;
      background: #f15a24;
      //border: 2px solid #cfd8dc;
      border-radius: 5px;
      content: ' ';
    }
  }

  .TabHeader {
    position: relative;
    background: white;
    height: 80px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:before {
      content: ' ';
      background : #00B8AB;
      border-radius : 0 5px 5px 0;
      width: 6px;
      height: 78px;
      position: absolute;
      top: 1px;
      left: -1px;
    }
  }

  .TabHeaderTitle {
    font-weight : bold;
    font-size : 19px;
    color : #37474F;
  }

  .TabHeaderSubtitle {
    font-size : 13px;
    color : #546E7A;
  }

  .aBtn {
    &.On:before {
      color: #00A99D !important;
    }

    &.Off:before {
      color: #546e7a !important;
    }
  }

  .MessagesDialogBody {
    height: 50vh;
    display: flex;
    flex-direction: column;
  }

  .Messages {
    flex: 1 1 100%;
    background: #ECEFF1;
    padding: 16px;
    overflow: auto;
    display: flex;
    flex-direction: column-reverse;
  }

  .MessageContainer {
    display: flex;

    &.OWN, &.SENT {
      justify-content: flex-end;
      padding-left: 10%;
    }

    &.RECEIVED, &.ADMIN {
      justify-content: flex-start;
      padding-right: 10%;
    }
  }

  .Message {
    margin: 5px 0;
    padding: 15px;
    padding-bottom: 6px;
    background : rgba(255, 255, 255, 0.5);
    font-size: 13px;
    line-height: 16px;
    color: #78909C;

    &.OWN, &.SENT {
      border-radius : 15px 15px 0 15px;
    }

    &.RECEIVED, &.ADMIN {
      border-radius : 15px 15px  15px 0;
    }

    &.OWN {
      background: #37474F;
      //color: #ECEFF1;
      color: rgba(236,239,241,0.8)

      .MessageText {
        color: #ECEFF1;
      }
    }

    &.ADMIN {
      background : #FFFFFF;
    }
  }

  .MessageBody {
    display: flex;
  }

  .MessageImage {
    flex: 0 0 40px;
    height: 40px;
    width: 40px;
    overflow: hidden;
    border-radius 20px;
    border: 1px solid white;
    background: #e7ebed;
    justify-content: center;

    img {
      width: 40px;
      height: 40px;
    }

    &:before {
      color: #78909c;
      font-size: 28px;
    }
  }

  .MessageFrom {
    padding: 3px 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .MessageText {
    padding: 0 10px;
    white-space: pre-line;
    font-size : 14px;
    line-height : 20px;
    color: #455A64;
  }

  .MessageTime {
    margin-top: 15px;
    &:before {
      padding-right: 3px;
      font-size: 17px;
    }
  }

  //.DateSeparator {
  //  text-align: center;
  //  font-size: 13px;
  //  font-weight: bold;
  //  color: #546E7A;
  //  border-top: 1px solid #B0BEC5;
  //  margin: 5px 30px;
  //}

  .BidStatus {
    font-size: 13px;
    line-height: 40px;
    color : #78909C;
    padding: 0 15px;

    &:before {
      padding-right: 3px;
      font-size: 17px;
    }
  }

  .NewMessageForm {
    box-sizing: border-box;
    flex: 1 0 68px;
    max-height: 130px;
    display: flex;
    padding: 20px;
    align-items: center;
  }

  .NewMessageTextArea {
    flex: 1 1 100%;
    padding-right: 10px;
  }

  button.SendMessage {
    align-self: flex-end;
  }

  button[data-icon-after] {
    padding-right: 5px;
  }

  .AvailabilityError {
    display: flex;
    flex: 0 0 auto;
    justify-content: center;
    align-items: center;
    padding: 20px;
    font-size: 14px;
    color: #37474f;
    width: 400px;
    text-align: center;
    margin: 20px auto;
    background: #eceff1;
    border-radius: 8px;
    font-weight: bold;
  }
</style>
